export const STATE_CLS = {
  COMPLETED: "border-emerald-300 bg-emerald-50 text-emerald-800",
  "IN PROGRESS": "border-sky-300 bg-sky-50 text-sky-800",
  PENDING: "border-slate-200 bg-slate-50 text-slate-600",
  "ACTION REQUIRED": "border-rose-300 bg-rose-50 text-rose-800",
  "NOT REQUIRED": "border-slate-200 bg-white text-slate-400",
};
export const DOT_CLS = { COMPLETED: "bg-emerald-500", "IN PROGRESS": "bg-sky-500", PENDING: "bg-slate-300", "ACTION REQUIRED": "bg-rose-500", "NOT REQUIRED": "bg-slate-200" };
export const ORDER_STATUS_CLS = {
  "ORDER CONFIRMED": "bg-slate-800 text-white", "PO RECEIVED": "bg-indigo-600 text-white", PROCESSING: "bg-sky-600 text-white", "PARTIALLY FULFILLED": "bg-amber-500 text-white",
  FULFILLED: "bg-emerald-600 text-white", COMPLETED: "bg-emerald-800 text-white", "ON HOLD": "bg-orange-600 text-white", CANCELLED: "bg-rose-700 text-white",
};
export const PRIORITY_CLS = { HIGH: "bg-rose-600 text-white", MEDIUM: "bg-amber-500 text-white", LOW: "bg-slate-400 text-white" };
export const CARDS = [
  ["procurement", "Procurement"], ["deployment", "Deployment Services"], ["documentation", "Documentation"],
  ["logistics", "Logistics"], ["payment", "Payment"], ["customer_experience", "Customer Experience"],
];
export const inr = (v) => (v == null || v === "" ? "—" : `₹${Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const errMsg = (e) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : d?.message || "Request failed"; };
